import React, {FC} from 'react'
import {PageTitle} from '@/_metronic/layout/core'
import {TableWrapper} from '@/components/table/TableWrapper'
import {ButtonProps, ModalWrapperProps} from '@/components/table/core/_types'
import {Modal} from '@/components/table/modal/Modal'
import {getSupplierOperations} from '../core/_requests'
import {SupplierOperation} from '../core/_models'
import {Columns} from './columns/_columns'
import DeleteForm from './components/DeleteForm'
import DuplicateForm from './components/DuplicateForm'
import SplitForm from './components/SplitForm'
import {FilterForm, initialFilters} from './components/FilterForm'
import BreadcrumbsBuilder from '@/components/layout/BreadcrumbsBuilder'

const Breadcrumbs = BreadcrumbsBuilder([{
  title: 'Home',
  path: '/'
}, {
  title: 'Passtocard',
  path: '/p2c/dashboard',
}, {
  title: 'Suppliers',
  path: '/p2c/supplier/list',
}])

/**
 * Toolbar buttons
 */
const buttons: Array<ButtonProps> = [{
  label: 'Deposit',
  className: 'btn btn-danger me-3',
  icon: {
    name: 'bank',
    className: 'fs-2'
  },
  openModal: 'deposit'
}, {
  label: 'Bulk Order',
  className: 'btn btn-info me-3',
  icon: {
    name: 'delivery-2',
    className: 'fs-2'
  },
  navigate: '/p2c/supplier/bulk-order'
}]


/**
 * Modal wrapper to manage open modal
 */
const OperationModalWrapper: FC<ModalWrapperProps> = ({itemForUpdate, action}) => {
  const operation = itemForUpdate as SupplierOperation
  return (
    <>
      {itemForUpdate && action === 'delete' && (
        <Modal title={`Delete operation ${operation.reference}`}>
          <DeleteForm />
        </Modal>
      )}

      {itemForUpdate && action === 'duplicate' && (
        <Modal title={`Duplicate operation ${operation.reference}` }  maxWidth={900}>
          <DuplicateForm />
        </Modal>
      )}

      {itemForUpdate && action === 'split' && (
        <Modal title={`Split operation ${operation.reference}` }  maxWidth={900}>
          <SplitForm />
        </Modal>
      )}

      {itemForUpdate && action === 'deposit' && (
        <Modal title={`Operation ${operation.reference}`}>
          <span>View deposit content</span>
        </Modal>
      )}
      {itemForUpdate === null && action === 'deposit' && (
        <Modal title="Create supplier">
          <span>Create deposit content</span>
        </Modal>
      )}
    </>
  )
}

const ListWrapper = () => {
  return (
    <>
      <PageTitle breadcrumbs={Breadcrumbs}>Operations</PageTitle>
      <TableWrapper
        dataProvider={getSupplierOperations}
        cols={Columns}
        queryId="SUPPLIERS_OP_LIST"
        lookup={{placeholder: 'Search Operation'}}
        modals={OperationModalWrapper}
        filters={{
          formFields: FilterForm,
          initialValues: initialFilters
        }}
        buttons={buttons}
      />
    </>
  )
}

export default ListWrapper
